import { api } from "@/lib/orgApi";

export const RADIOLOGY_CODING_SYSTEM = "http://loinc.org";

export async function listRadiology({ q, active, category, modality } = {}) {
  const params = {};
  if (q) params.q = q;
  if (active != null) params.active = active;
  if (category) params.category = category;
  if (modality) params.modality = modality;
  const { data } = await api.get("/radiology", { params });
  return data;
}

export async function getRadiology(studyId) {
  const { data } = await api.get(`/radiology/${encodeURIComponent(studyId)}`);
  return data;
}
